import "./App.css";
import { Suspense, lazy } from "react";
import AppRoutes from "./Home/Components/AppRoutes";
import { LoaderProvider } from "./Home/Loader/LoadContext";
import { AmyButton } from 'amy-ai';
import 'amy-ai/dist/index.css';
import WhatsAppFloatButton from "./Dashboard/Components/Watsapp";
import { HelmetProvider } from "react-helmet-async";

const LLMBot = lazy(() => import("./LLMBot/LLMBot"));

function App() {

  return (
    <LoaderProvider>
      <div className="App">
        <HelmetProvider>
          <AppRoutes />
        </HelmetProvider>
        <Suspense fallback={<></>}>
          {/* <LLMBot /> */}
          {
            !window.location.pathname.includes('landing-page') ?
              // <AmyButton data={[]} /> :
              <></>:
              <WhatsAppFloatButton />
          }
        </Suspense>
      </div>
    </LoaderProvider>
  );
}

export default App;
